import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required('msg_error_required_field'),
  email: Yup.string().email('msg_error_invalid_email_format').required('msg_error_required_field'),
  phone: Yup.string()
    .trim()
    .required('msg_error_required_field')
    .max(15, 'msg_error_invalid_phone'),
  address: Yup.string().trim(),
});
